// $(document).ready(function(){
//
//     $(".fa-search").click(function(){
//         $(".search-wrap, .search-input").toggleClass("active");
//         $("input[type='text']").focus();
//     });
//
// });

window.addEventListener("DOMContentLoaded", () => {
  const searchBtn = document.querySelector(".fa-search");
  const searchWrap = document.querySelector(".search-wrap");
  const searchInput = document.querySelector(".search-input");
  const navbarBrand = document.querySelector(".search-menu__logo");
  const topMenuLeft = document.querySelector(".search-menu__call");

  searchBtn?.addEventListener("click", () => {
    searchWrap.classList.toggle("active");
    searchInput.classList.toggle("active");
    searchInput.focus();

    if (window.matchMedia("(max-width: 767px)").matches) {
      if (searchWrap.classList.contains("active")) {
        navbarBrand.classList.add("hide");
        topMenuLeft.classList.add("hide");
      } else {
        navbarBrand.classList.remove("hide");
        topMenuLeft.classList.remove("hide");
      }
    } else if (window.matchMedia("(max-width: 769px)").matches) {
      if (searchWrap.classList.contains("active")) {
        topMenuLeft.classList.add("hide");
      } else {
        topMenuLeft.classList.remove("hide");
      }
    }
  });

  // if (window.matchMedia("(max-width: 799px)").matches) {
  //     if (searchWrap.classList.contains('active')) {
  //         navbarBrand.classList.add('hide');
  //         topMenuLeft.classList.add('hide');
  //     }
  // }
});
